/**
 * Form validation message severities.
 */
export const FORM_VALIDATION_MESSAGE_TYPES = {
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO'
}

/**
 * Form validation data keys, identifying what triggered a validation check.
 */
export const FORM_VALIDATION_DATA_KEYS = {
  ON_FIELD_CHANGE: 'on_field_change',
  ON_DELETE: 'on_delete'
}

/**
 * Form validation modes.
 */
export const FORM_VALIDATION_MODE = {
  EDIT: 'EDIT',
  DELETE: 'DELETE'
}

/**
 * Comparison operators used to build form validation conditions.
 */
export const FORM_VALIDATION_CONDITIONS = {
  EQUAL: 'EQUAL',
  SUPERIOR: 'SUPERIOR',
  SUPERIOR_OR_EQUAL: 'SUPERIOR_OR_EQUAL',
  INFERIOR: 'INFERIOR',
  INFERIOR_OR_EQUAL: 'INFERIOR_OR_EQUAL'
}
